module.exports = __webpack_public_path__ + "img/mosquita_forgotten_password.370bef28.png";